import React from "react";
import { Grid } from "@material-ui/core";
import { InputSelect } from "components/form";
import useAdditionalInformation from "./useAdditionalInformation";
import ButtonCustom from "components/buttonCustom";

import { Subtitle, GroupField, Input } from "../../../Styled";

import { Modal, ModalBody, ModalTitle } from "./Styled";
import { Small } from "../../../Styled";
import { LabelInfo } from './Styled'


const AdditionalInformation = ({ onNext }) => {
  const {
    dataFields,
    errors,
    getOptionsBloodType,
    isVigilant,
    listHeight,
    listSizesShoes,
    listSizesShirts,
    listSizesTshirts,
    listSizesPants,
    openModal,
    translate,
    handleCloseModal,
    handleChangeText,
    handleChangeSelect,
    //handleChangeCheckbox,
  } = useAdditionalInformation();


  return (
    <React.Fragment>
      <Modal open={openModal}>
        <ModalTitle>Primeira via CNV</ModalTitle>

        <ModalBody>
          Ao selecionar primeira via desconsidere o campo CNV
        </ModalBody>

        <ButtonCustom className="btn-green" onClick={handleCloseModal}>
          Entendi
        </ButtonCustom>
      </Modal>
      <Subtitle>
        {translate("workWithUs.form.step3.title")}
        <br />
        <Small>{translate("workWithUs.requiredFields")}</Small>
      </Subtitle>
      <Grid container spacing={2}>
        <Grid item xs={12} md={12} lg={12} xl={12}>
            <LabelInfo>Você pode pular essa etapa:
                <ButtonCustom className="btn-green" onClick={onNext}>
                    PULAR ETAPA
                </ButtonCustom>
            </LabelInfo>
        </Grid>
        {/* {isVigilant && (
          <>
            <Grid item xs={12} md={12} lg={9} xl={9}>
              <GroupField>
                <Input
                  fullWidth
                  transparent="true"
                  id="reservist"
                  name="reservist"
                  label={translate("workWithUs.form.step3.reservist")}
                  autoComplete="off"
                  value={dataFields?.basicInformation?.reservist || ""}
                  onChange={(props) =>
                    handleChangeText(props, "basicInformation")
                  }
                  error={errors?.basicInformation?.reservist}
                />
              </GroupField>
            </Grid>
          </>
        )} */}



        <Grid item xs={12} md={4} lg={6} xl={6}>
          <GroupField>
            <Input
              min="40"
              max="300"
              type="number"
              fullWidth
              transparent="true"
              id="weight"
              name="weight"
              label={translate("workWithUs.form.step3.weight")}
              autoComplete="off"
              value={dataFields?.basicInformation?.weight || ""}
              onChange={(props) => handleChangeText(props, "basicInformation")}
              error={errors?.basicInformation?.weight}
            ></Input>
          </GroupField>
        </Grid>

        <Grid item xs={12} md={4} lg={6} xl={6}>
          <GroupField>
            <InputSelect
              type="number"
              fullWidth
              transparent="true"
              id="height"
              name="height"
              label={translate("workWithUs.form.step3.height")}
              labeldark="false"
              autoComplete="off"
              value={dataFields?.basicInformation?.height || ""}
              onChange={(props) => handleChangeText(props, "basicInformation")}
              options={listHeight}
              error={errors?.basicInformation?.height}
            ></InputSelect>
          </GroupField>
        </Grid>

        <Grid item xs={12} md={4} lg={4} xl={4}>
          <GroupField>
            <InputSelect
              fullWidth
              transparent="true"
              id="sizePant"
              name="sizePant"
              label={translate("workWithUs.form.step3.sizePant")}
              labeldark="false"
              value={dataFields?.basicInformation?.sizePant || ""}
              onChange={(props) => handleChangeText(props, "basicInformation")}
              options={listSizesPants}
              error={errors?.basicInformation?.sizePant}
            ></InputSelect>
          </GroupField>
        </Grid>

        <Grid item xs={12} md={4} lg={4} xl={4}>
          <GroupField>
            <InputSelect
              fullWidth
              transparent="true"
              id="sizeShirt"
              name="sizeShirt"
              label={translate("workWithUs.form.step3.sizeShirt")}
              labeldark="false"
              value={dataFields?.basicInformation?.sizeShirt || ""}
              onChange={(props) => handleChangeText(props, "basicInformation")}
              options={listSizesShirts}
              error={errors?.basicInformation?.sizeShirt}
            ></InputSelect>
          </GroupField>
        </Grid>

        <Grid item xs={12} md={4} lg={4} xl={4}>
          <GroupField>
            <InputSelect
              fullWidth
              transparent="true"
              id="sizeTshirt"
              name="sizeTshirt"
              label={translate("workWithUs.form.step3.sizeTshirt")}
              labeldark="false"
              value={dataFields?.basicInformation?.sizeTshirt || ""}
              onChange={(props) => handleChangeText(props, "basicInformation")}
              options={listSizesTshirts}
              error={errors?.basicInformation?.sizeTshirt}
            ></InputSelect>
          </GroupField>
        </Grid>

        <Grid item xs={12} md={4} lg={6} xl={6}>
          <GroupField>
            <InputSelect
              fullWidth
              transparent="true"
              id="sizeJacket"
              name="sizeJacket"
              label={translate("workWithUs.form.step3.sizeJacket")}
              labeldark="false"
              value={dataFields?.basicInformation?.sizeJacket || ""}
              onChange={(props) => handleChangeText(props, "basicInformation")}
              options={listSizesTshirts}
              error={errors?.basicInformation?.sizeJacket}
            ></InputSelect>
          </GroupField>
        </Grid>

        <Grid item xs={12} md={4} lg={6} xl={6}>
          <GroupField>
            <InputSelect
              fullWidth
              transparent="true"
              id="sizeShoe"
              name="sizeShoe"
              label={translate("workWithUs.form.step3.sizeShoe")}
              labeldark="false"
              value={dataFields?.basicInformation?.sizeShoe || ""}
              onChange={(props) => handleChangeText(props, "basicInformation")}
              options={listSizesShoes}
              error={errors?.basicInformation?.sizeShoe}
            ></InputSelect>
          </GroupField>
        </Grid>

        <Grid item xs={12} md={4} lg={6} xl={6}>
          <GroupField>
            <InputSelect
              fullWidth
              transparent="true"
              id="availabilityPeriod"
              name="availabilityPeriod"
              label={translate("workWithUs.form.step3.availabilityPeriod")}
              labeldark="false"
              value={dataFields?.basicInformation?.availabilityPeriod || ""}
              onChange={(props) => handleChangeText(props, "basicInformation")}
              options={[
                { label: "DIURNO", value: "DIURNO" },
                { label: "NOTURNO", value: "NOTURNO" },
                { label: "AMBOS", value: "AMBOS" },
              ]}
              error={errors?.basicInformation?.availabilityPeriod}
            ></InputSelect>
          </GroupField>
        </Grid>

        <Grid item xs={12} md={4} lg={6} xl={6}>
          <GroupField>
            <InputSelect
              fullWidth
              transparent="true"
              id="availabilityTimetable"
              name="availabilityTimetable"
              label={translate("workWithUs.form.step3.availabilityTimetable")}
              labeldark="false"
              value={dataFields?.basicInformation?.availabilityTimetable || ""}
              onChange={(props) => handleChangeText(props, "basicInformation")}
              options={[
                { label: "4X2", value: "4X2" },
                { label: "5X1", value: "5X1" },
                { label: "5X2", value: "5X2" },
                { label: "6X1", value: "6X1" },
                { label: "12x36", value: "12x36" },
                { label: "18X36", value: "18X36" },
                { label: "24X48", value: "24X48" },
                { label: "Todos", value: "Todos" },
              ]}
              error={errors?.basicInformation?.availabilityTimetable}
            ></InputSelect>
          </GroupField>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default AdditionalInformation;
